import { render } from "./IconYoutube.vue?vue&type=template&id=b10d0b5a"
import script from "./IconYoutube.vue?vue&type=script&lang=js"
export * from "./IconYoutube.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__